module.exports = __webpack_public_path__ + "img/Wp_2040.4e6a7289.png";